var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "-2 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.598.65a7.76 7.76 0 0 1 5.521 2.287 7.76 7.76 0 0 1 2.287 5.522 7.76 7.76 0 0 1-2.287 5.522 7.753 7.753 0 0 1-4.323 2.196l-.328.043v3.115h1.203a.87.87 0 0 1 .11 1.734l-.11.006H9.468v1.405a.87.87 0 0 1-1.734.109l-.007-.11v-1.404H6.524a.87.87 0 0 1-.11-1.734l.11-.006h1.203V16.22l-.328-.043a7.753 7.753 0 0 1-4.323-2.196A7.76 7.76 0 0 1 .789 8.459a7.76 7.76 0 0 1 2.287-5.522A7.76 7.76 0 0 1 8.598.65zm0 1.74A6.075 6.075 0 0 0 2.529 8.46a6.075 6.075 0 0 0 6.069 6.068 6.075 6.075 0 0 0 6.068-6.068A6.075 6.075 0 0 0 8.598 2.39z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.bbda20d8ee2393b51eb6256b5d977fc2.svg";
export { ForwardRef as ReactComponent };